import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

/** Cuerpo `PerfilamientoRequest` (backend Java). Flags Si/No según contrato MP-FT-1358. */
export interface IntegrantePerfilamientoRequest {
  noRegistro: string;
  identificacion?: string;
  tipoIdentificacion?: string;
  nombreUsuario?: string;
  parentesco?: string;
  campaniaVigente: string;
  congelamiento: string;
  licenciaViajeExterior: string;
  idIntegrantesSolicitudRadicacion?: number | null;
}

export interface PerfilamientoValidarRequest {
  idTipoNovedad: number;
  numeroContrato: string;
  estadoContrato: string;
  acuerdoPagoVigente: string;
  moraContrato: string;
  integrantes: IntegrantePerfilamientoRequest[];
  idSolicitudesRadicadas?: number | null;
  lineaNegocioId?: string | null;
  grupoProgramaId?: string | null;
  programaId?: string | null;
  tipoPlanOrigenId?: string | null;
}

export interface ResultadoIntegrantePerfilamientoDTO {
  noRegistro: string;
  identificacion?: string;
  nombreUsuario?: string;
  resultado: string;
  bloqueaProceso: boolean;
  bloqueaUsuario: boolean;
  tieneAdvertencia: boolean;
  mensajeAlerta?: string | null;
}

export interface PerfilamientoValidarResponse {
  procesoBloqueado: boolean;
  mensajeBloqueo?: string | null;
  resultadosPorIntegrante?: ResultadoIntegrantePerfilamientoDTO[];
  integrantesCumplen?: unknown[];
  integrantesNoCumplen?: unknown[];
}

@Injectable({
  providedIn: 'root',
})
export class PerfilamientoValidarService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.PERFILAMIENTO_VALIDAR}`;

  constructor(private http: HttpClient) {}

  validar(
    body: PerfilamientoValidarRequest
  ): Observable<PerfilamientoValidarResponse> {
    return this.http.post<PerfilamientoValidarResponse>(this.apiUrl, body);
  }
}
